export var CharCodes;
(function (CharCodes) {
    CharCodes[CharCodes["Backspace"] = 8] = "Backspace";
})(CharCodes || (CharCodes = {}));
export function emulateInput(target, inputSequence) {
    target.focus();
    for (let i = 0; i < inputSequence.length; i++) {
        const charCode = inputSequence.charCodeAt(i);
        const start = target.selectionStart != null ? target.selectionStart : target.value.length;
        const end = target.selectionEnd != null ? target.selectionEnd : target.value.length;
        const before = target.value.substring(0, start);
        const after = target.value.substring(end);
        switch (charCode) {
            case CharCodes.Backspace:
                if (start == end) {
                    target.value = before.substr(0, before.length - 1) + after;
                }
                else {
                    target.value = before + after;
                }
                target.selectionStart = target.selectionEnd = start - 1;
                break;
            default:
                target.value = before + String.fromCharCode(charCode) + after;
                target.selectionStart = target.selectionEnd = start + 1;
                break;
        }
    }
}
//# sourceMappingURL=emulateInput.js.map